import * as moment from 'moment';

export const MomentTransformer = {
  Serialize(value: any): string {
    if (value == null) {
      return null;
    }
    return value.toISOString();
  },
  Deserialize(json: any): any {
    return moment(json);
  }
};
